







import {Component, Prop, Vue} from "vue-property-decorator";
import JsonViewer from 'vue-json-viewer'
import NewCriteriaTable from "@/valchrom/views/mathservice/dataset/overview/NewCriteriaTable.vue";

@Component({
    components: {
        NewCriteriaTable,
        JsonViewer,
        VisualComponent: () => import("@/valchrom/views/mathservice/dataset/overview/VisualComponent.vue")
    }
})
export default class Series extends Vue {
    @Prop() model: any;
}
